import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a7000dd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "grid" };
const _hoisted_2 = { class: "col-8" };
const _hoisted_3 = { class: "col-4" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "flex flex-column gap-2" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "font-bold" }, "Roles", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "is_system_admin" }, "System administrator", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "is_catalog_admin" }, "Catalog administrator", -1));
const _hoisted_9 = { class: "col-12 claims-description warning-span" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: { "font-size": "2rem", "margin-right": "20px", "color": "var(--purple-500)" }
}, null, -1));
const _hoisted_11 = { class: "col-12" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Authorized Brands", -1));
const _hoisted_13 = { class: "col-12" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Authorized Markets", -1));
const _hoisted_15 = { class: "col-12" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Authorized Websites", -1));
import { computed, onBeforeMount, ref } from "vue";
import Text from "@/shared/json/backOffice.json";
import BrandsMultiSelector from "@/components/molecules/BrandsMultiSelector.vue";
import MarketsMultiSelector from "@/components/molecules/MarketsMultiSelector.vue";
import WebsitesMultiSelector from "@/components/molecules/WebsitesMultiSelector.vue";
import { getUserClaims, purgeUserClaims, addUserClaims, deleteClaim } from "@/repositories/claims.repository";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import Checkbox from "primevue/checkbox";
import { ClaimType } from "@/entities/claim.entity";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { Roles } from "@/entities/user.entity";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpdateUserClaims',
    props: ['userData'],
    emits: ["update-requires-reload"],
    setup(__props, { emit: __emit }) {
        const notify = useToastNotify();
        const props = __props;
        const userClaims = ref([]);
        const emit = __emit;
        onBeforeMount(async () => await retrieveUserClaims());
        const retrieveUserClaims = async () => {
            userClaims.value = await getUserClaims(props.userData.id);
        };
        const getClaimsByType = (type) => userClaims.value.filter((claim) => claim.claimType === type);
        const brandClaims = computed(() => getClaimsByType(ClaimType.CAN_ACCESS_BRAND));
        const marketsClaims = computed(() => getClaimsByType(ClaimType.CAN_ACCESS_MARKET));
        const websitesClaims = computed(() => getClaimsByType(ClaimType.CAN_ACCESS_SITENAME));
        const adminClaims = computed(() => getClaimsByType(ClaimType.IS_ADMIN));
        const haveNoClaims = computed(() => userClaims?.value?.length === 0);
        const selectedBrandClaims = computed({
            get: () => brandClaims.value.map(c => c.claimValue),
            set: async (values) => {
                await addOrDeleteClaimsFromUser(values, brandClaims.value, ClaimType.CAN_ACCESS_BRAND);
            },
        });
        const selectedMarketClaims = computed({
            get: () => marketsClaims.value.map(c => c.claimValue),
            set: async (values) => {
                await addOrDeleteClaimsFromUser(values, marketsClaims.value, ClaimType.CAN_ACCESS_MARKET);
            },
        });
        const selectedWebsiteClaims = computed({
            get: () => websitesClaims.value.map(c => c.claimValue),
            set: async (values) => {
                await addOrDeleteClaimsFromUser(values, websitesClaims.value, ClaimType.CAN_ACCESS_SITENAME);
            },
        });
        const proxyIsAdmin = (role) => {
            return computed({
                get: () => adminClaims.value.some(c => c.claimValue === role),
                set: async (value) => {
                    if (value)
                        await addClaimsToUser(ClaimType.IS_ADMIN, [role]);
                    else {
                        const claimId = adminClaims.value.find(c => c.claimValue === role)?.id;
                        if (claimId)
                            await deleteClaimsFromUser([claimId]);
                    }
                    await retrieveUserClaims();
                    emit("update-requires-reload");
                },
            });
        };
        const proxyIsSystemAdmin = proxyIsAdmin(Roles.SystemAdmin);
        const proxyIsCatalogAdmin = proxyIsAdmin(Roles.CatalogAdmin);
        const addOrDeleteClaimsFromUser = async (newValues, oldValues, claimType) => {
            const { added, deleted } = compareArraysAndReturnAddedAndDeleted(oldValues.map(c => c.claimValue), newValues);
            if (added.length)
                await addClaimsToUser(claimType, added);
            if (deleted.length)
                await deleteClaimsFromUser(deleted.map(d => oldValues.find(c => c.claimValue === d).id));
        };
        const compareArraysAndReturnAddedAndDeleted = (oldArray, newArray) => {
            const added = newArray.filter((id) => !oldArray.includes(id));
            const deleted = oldArray.filter((id) => !newArray.includes(id));
            return { added, deleted };
        };
        const addClaimsToUser = async (claimType, newClaims) => {
            await addUserClaims(props.userData.id, claimType, newClaims);
            await retrieveUserClaims();
            if (claimType === ClaimType.IS_ADMIN || newClaims.length > 0) {
                notifyUpdateSuccessful("added");
            }
        };
        const deleteClaimsFromUser = async (ids) => {
            for (const id of ids) {
                try {
                    await deleteClaim(id);
                    notifyUpdateSuccessful("deleted");
                }
                catch (e) {
                    console.error("Error deleting claim", e);
                }
            }
            await retrieveUserClaims();
        };
        const onPurgeClaims = async () => {
            await purgeUserClaims(props.userData.id);
            await retrieveUserClaims();
            notifyUpdateSuccessful("purged");
        };
        const notifyUpdateSuccessful = (action) => {
            notify("Claims", `Claims for ${props.userData.account} has been successfully ${action}`, "success");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h6", null, _toDisplayString(__props.userData.displayName), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(OneDeskButton, {
                        class: "user-reset-claims-button",
                        disabled: haveNoClaims.value,
                        "accept-callback": onPurgeClaims,
                        "confirm-message": "reset ?",
                        "confirm-group": "reset",
                        icon: "pi pi-trash",
                        label: "Purge"
                    }, null, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", null, [
                            _createVNode(_unref(Checkbox), {
                                modelValue: _unref(proxyIsSystemAdmin),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(proxyIsSystemAdmin) ? (proxyIsSystemAdmin).value = $event : null)),
                                inputId: "is_system_admin",
                                name: "isSystemAdmin",
                                binary: "",
                                style: { "margin-right": "10px" }
                            }, null, 8, ["modelValue"]),
                            _hoisted_7
                        ]),
                        _createElementVNode("div", null, [
                            _createVNode(_unref(Checkbox), {
                                modelValue: _unref(proxyIsCatalogAdmin),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(proxyIsCatalogAdmin) ? (proxyIsCatalogAdmin).value = $event : null)),
                                inputId: "is_catalog_admin",
                                name: "isCatalogAdmin",
                                binary: "",
                                style: { "margin-right": "10px" }
                            }, null, 8, ["modelValue"]),
                            _hoisted_8
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_unref(Text).MarketBrandClaimsText), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createVNode(BrandsMultiSelector, {
                        modelValue: selectedBrandClaims.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedBrandClaims).value = $event)),
                        filter: true,
                        class: "claims-selector"
                    }, {
                        label: _withCtx(() => [
                            _hoisted_12
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(MarketsMultiSelector, {
                        modelValue: selectedMarketClaims.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedMarketClaims).value = $event)),
                        filter: true,
                        class: "claims-selector"
                    }, {
                        label: _withCtx(() => [
                            _hoisted_14
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createVNode(WebsitesMultiSelector, {
                        modelValue: selectedWebsiteClaims.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedWebsiteClaims).value = $event)),
                        filter: true,
                        class: "claims-selector"
                    }, {
                        label: _withCtx(() => [
                            _hoisted_16
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ])
            ]));
        };
    }
});
